import { render, staticRenderFns } from "./PageLocationList.vue?vue&type=template&id=4c10b674"
import script from "./PageLocationList.vue?vue&type=script&lang=js"
export * from "./PageLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports